module.exports = __webpack_public_path__ + "static/img/bg_reward_item_white.b0380182.png";